import React from 'react'

import { isLocal } from '../../utility'
import './loader.css'

export function Loader({
  showBackground = true,
  isTransparent = false,
  isLoading = false,
}) {
  return (
    <div
      className={[
        showBackground && 'u-bgColorOffwhite',
        isTransparent && 'is-transparent',
        !isLoading && 'u-hidden',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="u-padding6gu u-marginBottom4gu">
        <div className="u-textCenter">
          <img
            src={`${
              isLocal() ? '/cti-site' : ''
            }/webfiles/latest/assets/cti/images/cti-page-loader-icon.gif`}
            alt="Loading"
          />
        </div>
      </div>
    </div>
  )
}
